<template>
<div>
  <multiselect 
  v-model="output"
   deselect-label 
   :track-by="id" 
   :label="label" 
   :options="options" 
   :multiple="true"
    :close-on-select="false" 
    :clear-on-select="false" 
    :preserve-search="true"
    :placeholder="$lang.multiselect.placeholder"
     :searchable="true" 
     :allow-empty="true" 
     :show-labels="true"
    :selectLabel="$lang.multiselect.selectLabel" 
    :selectedLabel="$lang.multiselect.selectedLabel" 
    :loading="loading"
    :class="(isValid===null)?'':(isValid)?'multiselect__valid':'multiselect__invalid'" @remove="removeItem"
    @select="selectItem" @input="updateValue">
    <template slot="noOptions">
      <strong>{{$lang.multiselect.noOptions}}</strong>
    </template>
    <template slot="noResult">
      <strong>{{$lang.multiselect.noResult}}</strong>
    </template>
    <!-- <template slot="singleLabel" slot-scope="{ option }">
      <span>{{ option[label] }}</span>
    </template>-->

    <!-- <template slot="tag" slot-scope="{ option, remove }">
      <span>
        <span>{{ option[label]}}</span>
        <span class="custom__remove" @click="remove(option)">❌</span>
      </span>
    </template>-->
  </multiselect>

</div>

</template>

<script>
  import Multiselect from "vue-multiselect";
  export default {
    components: {
      Multiselect
    },
    props: {
      value: {
        type: Array
      },
      id: {
        type: String,
        default: "value"
      },

      isValid: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        default: "text"
      },
      options: {
        type: Array,
        default () {
          return [];
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      selectItem: {
        type: Function,
        default: () => {}
      },
      removeItem: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      return {
        output: this.value
      };
    },
    methods: {


      updateValue() {
        this.$emit("input", this.output);
      }
    },
    watch: {
      value() {
        this.output = this.value;
      }
    }
  };

</script>
